import * as React from "react";

// style, design
import { ToolTipCell, LinkedObject } from "../../Displays";

import SimpleTextFilter from "src/components/Lists/Base/CompleteList/Filters/TextFilter";
import NumberRangeFilter from "src/components/Lists/Base/CompleteList/Filters/NumberRangeFilter";
import { detailUrl as realEstateDetailUrl } from "../../../store/realEstates";

import { toSqmString } from "../../utils/stringUtils";

import StateFilter from "./Filters/StateFilter";
import CategoryFilter from "./Filters/CategoryFilter";

import { StatusLabel } from "src/components/Lists/Base/CompleteList/styles";
import { renderFloors } from "../../Forms/Base/FieldComponents/FloorSelector";
import { TextButton } from "../../Forms/Base/Buttons";

export default ({ onExcludeClicked } = {}) => {
  const cols = [
    {
      Header: "",
      id: "exclude",
      Cell: ({ row }) => {
        return (
          <TextButton
            red
            iconType="close"
            title="Exkludera"
            clicked={() => onExcludeClicked(row)}
          />
        );
      },
      disableSortBy: true,
      disableFilters: true,
      disableGlobalFilter: true,
    },
    {
      Header: "Status",
      accessor: "state",
      Cell: ({ value, row }) => (
        <StatusLabel state={row.original.state} contentType="premises">
          {row.original.state_display}
          {row.original.subletted ? " (andrahand)" : ""}
        </StatusLabel>
      ),
      Filter: StateFilter,
      filter: "textExact",
    },
    {
      Header: "Objektsnummer",
      accessor: "premises_id",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Kategori",
      accessor: "category",
      Cell: ({ row }) => {
        return <ToolTipCell text={row.original.category_display} />;
      },
      Filter: CategoryFilter,
      filter: "text",
    },
    {
      Header: "Adress",
      accessor: "address.str_representation",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Fastighet",
      accessor: "realestate.str_representation",
      Cell: ({ row }) => {
        const value = row.original.realestate;
        return <LinkedObject obj={value} urlMethod={realEstateDetailUrl} />;
      },
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Byggnad",
      accessor: "building.str_representation",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Våning",
      accessor: "dynamic_floors",
      // for convenience, backend allow filtering on summed_floors
      id: "dynamicFloors",
      Cell: ({ value }) => <ToolTipCell text={renderFloors(value)} />,
      // Filter: SimpleTextFilter,
      // filter: "text",
      disableSortBy: true,
      disableFilters: true,
      disableGlobalFilter: true,
    },
    {
      Header: "Area",
      accessor: "area",
      Cell: ({ value }) => <ToolTipCell text={toSqmString(value)} />,
      Filter: NumberRangeFilter,
      filter: "between",
    },
  ];

  return cols;
};
